const SCREENSHOT_UPDATE_TRIGGERS = {
  REFRESH: 'refresh',
  TAKE_NEW: 'take_new',
  MANUAL_RETAKE: 'manual_retake',
  MANUAL_RETAKE_DYNAMIC: 'manual_retake_dynamic_elements',
  MANUAL_RETAKE_COOKIES_BANNERS: 'manual_retake_cookies_banners',
  MANUAL_RETAKER_SHORTCUT: 'manual_retaker_shortcut',
};

export const HEATMAP_VIEWED_TRIGGERS = {
  URL_SEARCH: 'url_search',
  AUTOCOMPLETE: 'autocomplete',
  DEFAULT_PAGE: 'default_page',
  SAVED_HEATMAP: 'saved_heatmap',
  ...SCREENSHOT_UPDATE_TRIGGERS,
};

export const EVENT_TRIGGERS = {
  SEARCH_BAR: 'heatmap_search_bar',
  SIDE_BAR: 'heatmap_sidebar',
  SAVE_BUTTON: 'heatmap_save_button',
  ...SCREENSHOT_UPDATE_TRIGGERS,
};

export const EVENT_TRIGGERED_ON = {
  REPORT: 'heatmap.report.continuous-capture',
  SIDE_BAR: 'heatmap.list.continuous-capture-sidebar',
  HEADER: 'heatmap.list.continuous-capture-header',
};
